

















import { Component } from 'vue-property-decorator';
import Slide from '@/presentation/slides/Slide';

@Component({ components: {} })
export default class Cover extends Slide {
  get title() {
    if (this.section.Title) {
      return this.section.Title;
    }
    switch (this.section.SubType) {
      case 'cashflow':
        return 'Kassaflödesanalys';
      case 'flexible':
        return 'Flexibel presentation';
      case 'competitors':
        return 'Konkurrentjämförelse';
      case 'industryAnalysis':
        return 'Branschjämförelse';
      case 'competitorAnalysis':
        return 'Konkurrentjämförelse';
      case 'preClosingMeeting':
        return 'Inför bokslut ';
    }
    return this.overview.NAME;
  }

  get subTitle() {
    switch (this.section.SubType) {
      case 'preClosingMeeting':
        return this.overview.NAME;
    }
    return undefined;
  }

  get subType() {
    return this.section.SubType;
  }
}
